import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Link as MuiLink, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const STORAGE_KEY = "tasksuite_cookie_consent_v1";

export const getAnalyticsConsent = () => {
  if (typeof window === "undefined") return false;
  try { return window.localStorage.getItem(STORAGE_KEY) === "analytics"; } catch { return false; }
};

const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      setOpen(!saved);
    } catch {
      setOpen(false);
    }
  }, []);

  const choose = (value) => {
    try { window.localStorage.setItem(STORAGE_KEY, value); } catch {}
    setOpen(false);
    window.dispatchEvent(new CustomEvent("tasksuite:cookie-consent", { detail: value }));
  };

  if (!open) return null;

  return (
    <Alert
      severity="info"
      icon={false}
      role="region"
      aria-label="Privacy and cookie choices"
      sx={{
        position: "fixed",
        left: { xs: 12, md: 24 },
        right: { xs: 12, md: 24 },
        bottom: 12,
        zIndex: 1500,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: 8,
        borderRadius: 3,
        alignItems: "center",
        backdropFilter: "blur(14px)",
      }}
    >
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ xs: "stretch", md: "center" }} justifyContent="space-between">
        <Box sx={{ maxWidth: 820 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.4 }}>Privacy choices</Typography>
          <Typography variant="body2">
            TaskSuite uses essential browser storage to operate the service. Optional analytics is off until you allow it.{" "}
            <MuiLink component={Link} to="/cookies">Read the Cookie & Storage Policy</MuiLink>.
          </Typography>
        </Box>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ flexShrink: 0 }}>
          <Button variant="outlined" size="small" onClick={() => choose("essential")}>Essential only</Button>
          <Button variant="contained" size="small" onClick={() => choose("analytics")}>Allow analytics</Button>
        </Stack>
      </Stack>
    </Alert>
  );
};

export default CookieConsent;
